import { render, staticRenderFns } from "./ArticleVersionsFooter.vue?vue&type=template&id=685ec4b8&"
import script from "./ArticleVersionsFooter.vue?vue&type=script&lang=ts&"
export * from "./ArticleVersionsFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleVersionsFooter.vue?vue&type=style&index=0&id=685ec4b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports